import { useContext, useMemo } from "react";



import styled, { useTheme } from "styled-components";
import { borderRadius, cursor, padding, shadeOnHover } from "theme";

import FnrButtonWrapper from "UI/FnrButtonWrapper";
import FnrChevron from "UI/FnrChevron";
import FnrLoadingBricks from "UI/FnrLoadingBricks2";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

import { FnrAccordionContext } from "./FnrAccordion";
import Label from "./Label";
import { accordionLabelMargin, accordionLabelWidth } from "./interpolations";


const SFnrButtonWrapper = styled(FnrButtonWrapper)`
  ${cursor}
  ${padding}
  ${borderRadius}
  ${shadeOnHover}
  ${accordionLabelWidth}
  ${accordionLabelMargin}
  ${({ $backgroundColor }) =>
    $backgroundColor ? `background-color: ${$backgroundColor};` : ""}
  transition: margin .3s, width .3s, background-color .3s, border-radius .3s;
  ${({ $border }) => ($border ? `border: ${$border};` : "")}
`;

const ExpandButton = () => {
  const {
    addCard,
    active,
    buttonRef,
    cardIsShowing,
    chevronStyle,
    dark,
    fullWidth,
    handleToggle,
    hoverBackgroundColor: hoverBackgroundColorArg,
    isLoading,
    label,
    noShade,
    buttonBackgroundColor,
    buttonBorder,
  } = useContext(FnrAccordionContext);
  const {
    colors: { fnBlue, textLight, fnMediumGrey },
  } = useTheme();

  const hoverBackgroundColor = useMemo(() => {
    if (hoverBackgroundColorArg && !cardIsShowing)
      return hoverBackgroundColorArg;
    if (dark) return "divider";
    // we darken the top if there is a card, so the default needs to be a darker shade on hover
    if (addCard && active) return "fnDarkGrey";
    return "fnMediumGrey";
  }, [addCard, dark, hoverBackgroundColorArg, active, cardIsShowing]);

  if (!label) return null;
  return (
    <SFnrButtonWrapper
      onClick={handleToggle}
      $hoverBackgroundColor={hoverBackgroundColor}
      $paddingOffset={addCard && active ? 1.25 : 0}
      $noShade={noShade}
      $insideBorder={cardIsShowing}
      $squareBottom={cardIsShowing}
      $fullWidth={fullWidth}
      ref={buttonRef}
      $backgroundColor={
        addCard && active ? fnMediumGrey : buttonBackgroundColor
      }
      $border={buttonBorder}
    >
      <FnrHorizontalGap fullWidth={fullWidth} data-cy="FnrAccordion_Label">
        {chevronStyle === "left" && <FnrChevron active={active} dark={dark} />}
        {label && <Label label={label} dark={dark} />}
        {(chevronStyle === "right" || isLoading) && (
          <FnrHorizontalGap reverse={fullWidth}>
            {chevronStyle === "right" && (
              <FnrChevron active={active} dark={dark} />
            )}
            {isLoading && (
              // TODO: make this fade in and out and do not take up the space when invisible.
              <FnrLoadingBricks
                color={dark ? textLight : fnBlue}
                loading={isLoading}
                size={16}
              />
            )}
          </FnrHorizontalGap>
        )}
      </FnrHorizontalGap>
    </SFnrButtonWrapper>
  );
};

export default ExpandButton;